<template>
	<ul class="pagination pull-right">
		<li v-if="pagination.current_page > 1">
			<router-link aria-label="Previous" :to="{ query: { page: pagination.current_page - 1 } }">
				<span aria-hidden="true">«</span>
			</router-link>
		</li>
		<li v-for="(page, index) in pagesNumber" :key="index" :class="{'active': page == pagination.current_page}">
			<router-link aria-label="Previous" :to="{ query: { page } }">
				{{ page }}
			</router-link>
		</li>
		<li v-if="pagination.current_page < pagination.last_page">
			<router-link aria-label="Next" :to="{ query: { page: pagination.current_page + 1 } }">
				<span aria-hidden="true">»</span>
			</router-link>
		</li>
	</ul>
</template>

<script>
export default{
	props: {
		pagination: {
			type: Object,
			required: true
		},
		offset: {
			type: Number,
			default: 2
		}
	},
	computed: {
		pagesNumber() {
			if (!this.pagination.to) {
				return [];
			}
			let from = this.pagination.current_page - this.offset;
			if (from < 1) {
				from = 1;
			}
			let to = from + (this.offset * 2);
			if (to >= this.pagination.last_page) {
				to = this.pagination.last_page;
			}
			let pagesArray = [];
			for (let page = from; page <= to; page++) {
				pagesArray.push(page);
			}
			return pagesArray;
		}
	},
}
</script>
